import { createContext, useContext, useState, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { isFunction } from "../../utils/type-util";
import { jsx as _jsx } from "react/jsx-runtime";
const PortalContext = /*#__PURE__*/createContext(undefined);
export function Portal(_ref) {
  let {
    container,
    onMount,
    onUnmount,
    children
  } = _ref;
  const [portal] = useState(() => document.createElement("div"));
  const parentPortal = useContext(PortalContext);
  useLayoutEffect(() => {
    const containerEl = isFunction(container) ? container() : container;
    const el = containerEl ?? parentPortal ?? document.body;
    el?.appendChild(portal);
    onMount?.();
    return () => {
      onUnmount?.();
      if (el?.contains(portal)) {
        el?.removeChild(portal);
      }
    };
  }, [container, portal, parentPortal]);
  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsx(PortalContext.Provider, {
    value: portal,
    children: children
  }), portal);
}
export default Portal;